import { styled, Box } from '@mui/system';
import { Add, Check } from '@mui/icons-material';
import { theme } from '../../lib/index';

function Focus({ checked, children }) {
  const FocusBox = styled(Box, {})({
    display: 'flex',
    margin: 10,
    padding: '5px 10px 5px 20px',

    gap: 20,
    alignItems: 'center',

    borderRadius: '3px',
    border: checked ? '1px solid transparent' : `1px solid ${theme.palette.lightgrey}44`,
    background: checked ? theme.palette.newPrimary : theme.palette.backgroundgrey,

    wordBreak: 'break-word',
    hyphens: 'auto',
  });

  return (
    <FocusBox>
      {checked ? <Check /> : <Add sx={{ transform: 'rotate(45deg)' }} />}
      {children}
    </FocusBox>
  );
}

export default Focus;
